import { render, staticRenderFns } from "./ShippingReportTable.vue?vue&type=template&id=332fae30&scoped=true"
import script from "./ShippingReportTable.vue?vue&type=script&lang=js"
export * from "./ShippingReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332fae30",
  null
  
)

export default component.exports